import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import Config from '../config/config';
import { snakeToCamel } from '../../utils/common/common';
import AuthUtils from '../../utils/auth.utils';

class HttpClient {
  protected readonly axiosClient: AxiosInstance;

  constructor() {
    const token = AuthUtils.getAccessToken();

    this.axiosClient = axios.create({
      baseURL: Config.WALLET_HOST as string,
      timeout: 6000,
    });

    if (token) {
      this.setHeader('Authorization', `Bearer ${token}`);
    }

    this.axiosClient.interceptors.response.use((response) => ({
      ...response,
      data: snakeToCamel(response.data),
    }));

    this.axiosClient.interceptors.request.use((request) => {
      const actualToken = AuthUtils.getAccessToken();

      if (actualToken && request.headers) {
        request.headers.Authorization = `Bearer ${actualToken}`;
      }

      return {
        ...request,
        data: request.data,
      };
    });
  }

  setHeader = (header: string, value: string) => {
    this.axiosClient.defaults.headers.common[header] = value;
  };

  get = async <T>(url: string): Promise<T> => {
    const { data } = await this.axiosClient.get(url);
    return data as T;
  };

  post = async <T>(url: string, body: unknown, option?: AxiosRequestConfig) => {
    const { data } = await this.axiosClient.post(url, body, option);
    return data as T;
  };

  patch = async <T>(url: string, body: unknown, option?: AxiosRequestConfig) => {
    const { data } = await this.axiosClient.patch(url, body, option);
    return data as T;
  };
}

export default HttpClient;
